import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { debounce } from 'lodash';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

import { PRODUCT_ROUTES } from '../../../constants';

import IconRight from '../../../../images/icons/misc/icon-c-right.svg';

import styles from './NextUpEvent.module.scss';

const NextUpEvent = ({
  id,
  name,
  status,
  inRunningFlag,
  product,
  subscribeToEvent,
  unsubscribeToEvent,
  sportUrlName,
  getCalendar
}) => {
  const isClosed = status === 'closed';

  const subscribe = useMemo(() => debounce(eventId => subscribeToEvent(eventId), 300), []);
  const unsubscribe = useMemo(() => debounce(eventId => unsubscribeToEvent(eventId), 300), []);

  const onEventClick = () => {
    track('Event Page', 'Next Up Event click');
  };

  useEffect(() => {
    if (id) {
      subscribe(id);
    }

    return () => {
      unsubscribe(id);
    };
  }, [id]);

  useEffect(() => {
    if (isClosed) {
      getCalendar({ tags: [sportUrlName] }, { noThrottle: true, loading: false });
    }
  }, [isClosed, sportUrlName]);

  const productUrlPrefix = PRODUCT_ROUTES[product];
  const eventLink = `${productUrlPrefix}/events/${id}`;

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--inPlay']]: inRunningFlag && !isClosed,
  });

  return (
    <Link className={mainClass} to={eventLink} onClick={onEventClick}>
      <span>{!id || isClosed ? 'Loading Next Race...' : 'Next Race'}</span>
      {Boolean(id) && !isClosed && (
        <Fragment>
          <span className={styles.eventName}>
            {name}
          </span>
          <IconRight className={styles.action} />
        </Fragment>
      )}
    </Link>
  );
};

NextUpEvent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  inRunningFlag: PropTypes.bool,
  product: PropTypes.string,
  sportUrlName: PropTypes.string,
  getCalendar: PropTypes.func.isRequired,
  subscribeToEvent: PropTypes.func.isRequired,
  unsubscribeToEvent: PropTypes.func.isRequired
};

export default NextUpEvent;
